import { InputProps } from "./types";

export const Input = ({
  name,
  id,
  label,
  type,
  placeholder,
  onChange,
  isChecked,
}: InputProps) => {
  return (
    <span className="input-container">
      {label && <label className="input-label">{label}</label>}
      <input
        name={name}
        id={id}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        checked={isChecked ? isChecked(name, id) : null}
        className="input"
      />
    </span>
  );
};
